import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { Shell } from './components/Shell';
import { Loading } from './components/Feedback';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { TicketsPage } from './pages/TicketsPage';
import { TicketDetailPage } from './pages/TicketDetailPage';
import { EquipmentHistoryPage } from './pages/EquipmentHistoryPage';
import { ProgressPage } from './pages/ProgressPage';
import { ClosePage } from './pages/ClosePage';
import { StockPage } from './pages/StockPage';
import { StockTransferPage } from './pages/StockTransferPage';
import { ReportsPage } from './pages/ReportsPage';
import { ModuleEntry, ModuleGuard } from './components/ModuleAccess';
import { ModulesDashboardPage } from './pages/ModulesDashboardPage';
import { NoModuleAccessPage } from './pages/NoModuleAccessPage';
import { LeadsPage } from './pages/LeadsPage';
import { LeadEditorPage } from './pages/LeadEditorPage';
import { ChecksPage } from './pages/ChecksPage';
import { CheckEditorPage } from './pages/CheckEditorPage';

function Protected() {
  const { user, ready } = useAuth(); const location = useLocation();
  if (!ready) return <Loading />;
  return user ? <Outlet /> : <Navigate to="/login" replace state={{ from: location.pathname }} />;
}

export function App() {
  return <Routes>
    <Route path="/login" element={<LoginPage />} />
    <Route element={<Protected />}>
      <Route index element={<ModuleEntry />} />
      <Route path="/modules" element={<ModulesDashboardPage />} />
      <Route path="/no-module-access" element={<NoModuleAccessPage />} />
      <Route element={<ModuleGuard alias="tichete" />}>
        <Route element={<Shell />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/tickets" element={<TicketsPage />} />
          <Route path="/tickets/:id" element={<TicketDetailPage />} />
          <Route path="/tickets/:id/history" element={<EquipmentHistoryPage />} />
          <Route path="/tickets/:id/progress" element={<ProgressPage />} />
          <Route path="/tickets/:id/close" element={<ClosePage />} />
          <Route path="/stock" element={<StockPage />} />
          <Route path="/stock/transfer" element={<StockTransferPage />} />
          <Route path="/reports" element={<ReportsPage />} />
        </Route>
      </Route>
      <Route element={<ModuleGuard alias="leads" />}>
        <Route path="/leads" element={<LeadsPage />} />
        <Route path="/leads/new" element={<LeadEditorPage />} />
        <Route path="/leads/:leadId" element={<LeadEditorPage />} />
      </Route>
      <Route element={<ModuleGuard alias="check" />}>
        <Route path="/checks" element={<ChecksPage />} />
        <Route path="/checks/new" element={<CheckEditorPage />} />
        <Route path="/checks/:checkId" element={<CheckEditorPage />} />
      </Route>
    </Route>
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>;
}
